import * as core from '../../../../../../../core'
import * as stakeholderPerceivedAttitude from '../stakeholder-perceived-attitude'

export const RESOURCE = {
  payload: {
    description: 'Unknown',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderPerceivedAttitude.RESOURCE.payload.partialId,
    }),
    id: 'Unknown',
    name: 'Unknown',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
